import React from 'react'
import { Grid } from '@mui/material'

import { InputNormalizers, TextFieldControl } from '../form'

import { ResendCode } from './resend-code.tsx'

export interface VerifyCodeProps {
  login: string
  name?: string
  apiUrl: string

  codeLifespanMin?: number
}

export const VerifyCodeField = ({ name = 'code', ...props }: VerifyCodeProps): React.ReactElement => {
  return (
    <Grid item xs={12}>
      <TextFieldControl name={name} label="Код подтверждения" fullWidth normalize={InputNormalizers.digitsOnly} />
      <ResendCode {...props} />
    </Grid>
  )
}
